// @vue/component
export default {
  name: 'DashboardProjectList',

  props: {
    projectList: {
      type: Array,
      default: () => [],
    },

  },
  data() {
    return {
      active: 'all',
    };
  },

  methods: {
    changeProject(projectName) {
      this.active = projectName;
      this.$emit('changeProject', projectName);
    },
  },
};
